<template>
  <div class="flex flex-col lg:flex-row lg:space-x-4 relative">
    <div class="flex flex-col lg:w-2/5 justify-between md:py-8 py-4 lg:pr-4">
      <div class="space-y-4 text-left">
        <p class="md:text-4xl text-3xl font-bold" v-html="$t('quiz.question')"></p>
        <p class="uppercase" v-html="$t('quiz.select_correct')"></p>
      </div>

      <div class="flex flex-col space-y-4">
        <button
          class="button--answer"
          v-if="!showAnswer"
          @click="answer('yes')"
          v-html="$t('quiz.yes')"
        ></button>
        <button
          class="button--answer"
          v-if="!showAnswer"
          @click="answer('no')"
          v-html="$t('quiz.no')"
        ></button>
        <div
          class="alert"
          v-if="showAnswer"
          :class="{
            'alert--correct': correct,
            'alert--wrong': !correct,
          }"
        >
          <p v-if="correct" v-html="$t('quiz.correct')"></p>
          <p v-else v-html="$t('quiz.wrong')"></p>
        </div>
      </div>
    </div>
    <div class="lg:w-3/5">
      <div class="relative">
        <img
          :src="`./images/${$i18n.locale}/${questionImage}`"
          class="invisible"
          alt="Melanoma QUIZ image"
        />
        <transition name="fade" mode="in-out">
          <div v-if="!showAnswer" key="question" class="absolute inset-0">
            <img :src="`./images/${$i18n.locale}/${questionImage}`" alt="Melanoma QUIZ image" />
          </div>
          <div v-if="showAnswer" key="answer" class="absolute inset-0">
            <img :src="`./images/${$i18n.locale}/${answerImage}`" alt="Melanoma QUIZ image" />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionScreen",
  props: {
    questionImage: String,
    answerImage: String,
    correct: Boolean,
    showAnswer: Boolean,
  },
  data() {
    return {
      selectedAnswer: "",
    };
  },
  methods: {
    answer(value) {
      this.selectedAnswer = value;
      this.$emit("answer", value);
    },
  },
};
</script>

<style scoped lang="scss">
.button--answer {
  color: #000;
  font-size: 1.125rem;
  font-weight: 500;
  text-transform: uppercase;
  border: 1px solid #000;
  border-radius: 5px;
  padding: 1rem 1.5rem;
}

.alert {
  position: relative;
  padding: 1rem 1rem;
  background-color: var(--clr-gray-100);
  border-radius: 5px;
  color: #fff;
  font-size: 1.125rem;
  font-weight: 700;

  &--correct {
    background-color: var(--clr-green);
  }
  &--wrong {
    background-color: var(--clr-red);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
